import React, { useContext, useEffect } from 'react';

import { useQuery } from '@apollo/client';
import { Redirect, useParams } from 'react-router-dom';

import { Loader } from '../../../components/Loader';
import { LAST_VIEWED_PATHWAY_SLUG_COOKIE_NAME } from '../../../const';
import { UserInfoCtx } from '../../../containers/CommonLayout/CommonLayout';
import { GET_PATHWAY_PAGE_INFO, GET_PATHWAY_PAGE_PROGRESS } from '../../../graphql/pathways';
import {
  Query,
  QueryGetPathwayLearnerPageInfoArgs,
  QueryGetPathwayPageInfoArgs,
} from '../../../types';
import Cookie from '../../../utils/cookies';
import { formatProgressData } from '../../../utils/helpers';
import useIsSSR from '../../../utils/hooks/useIsSSR';
import { formatPathwayVideos } from '../../helpers';

const ContinueWatching = () => {
  const params = useParams();
  const slug = params?.slug;
  const { userInfo } = useContext(UserInfoCtx);
  const isSSR = useIsSSR();

  const { data: pathwayProgressData, loading: loadingProgressData } = useQuery<
    Pick<Query, 'getPathwayLearnerPageInfo'>,
    QueryGetPathwayLearnerPageInfoArgs
  >(GET_PATHWAY_PAGE_PROGRESS, {
    variables: {
      filter: {
        slug,
      },
    },
    skip: !userInfo || isSSR,
    fetchPolicy: 'network-only',
  });

  const { data: pathwayData, loading: loadingPathwayData } = useQuery<
    Pick<Query, 'getPathwayPageInfo'>,
    QueryGetPathwayPageInfoArgs
  >(GET_PATHWAY_PAGE_INFO, {
    variables: {
      filter: {
        slug,
      },
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    Cookie.set(LAST_VIEWED_PATHWAY_SLUG_COOKIE_NAME, slug);
  }, [slug]);

  const progressData = formatProgressData(pathwayProgressData?.getPathwayLearnerPageInfo?.progress);
  const pathwayVideos = formatPathwayVideos(
    pathwayData?.getPathwayPageInfo?.pathway?.videos,
    progressData,
  );

  const firstStartedVideo = pathwayVideos.find((video) => !video.completed && video.progress > 0);
  const firstNotStartedVideo = pathwayVideos.find(
    (video) => !video.completed && video.progress === 0,
  );
  const videoToContinuePathway = firstStartedVideo || firstNotStartedVideo;
  const link = videoToContinuePathway?.link;

  if (loadingProgressData || loadingPathwayData || !userInfo) {
    return <Loader />;
  }

  if (link) {
    return <Redirect to={link} />;
  }

  return <Loader />;
};

export default ContinueWatching;
